import { adminVerificationQueryKeys as e } from "./adminVerificationQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { verificationApi as n } from "@maat/api-main";
//#region src/verification/admin/useAdminVerificationQuery.ts
var r = (r, i) => t({
	queryKey: e.detail(r, i),
	queryFn: () => n.adminGetVerification(r, i),
	enabled: !!r && !!i
});
//#endregion
export { r as useAdminVerificationQuery };
